var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSopEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Confirm SOP Read",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 844,
    transform: "translate(-151 -184)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mark_email_unread_FILL0_wght200_GRAD0_opsz24 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.923 69.6666C15.2355 69.6666 13.8264 69.1013 12.6958 67.9707C11.5653 66.8402 11 65.4311 11 63.7435V24.2563C11 22.5687 11.5653 21.1596 12.6958 20.0291C13.8264 18.8985 15.2355 18.3332 16.923 18.3332H53.3923C53.2889 18.9443 53.2254 19.5437 53.202 20.1313C53.1784 20.7189 53.1949 21.3418 53.2513 21.9999H15.7949L44 40.3332L57.1013 31.78C57.5338 32.1984 57.9721 32.6039 58.4163 32.9964C58.8606 33.3889 59.3272 33.7521 59.8161 34.0858L44 44.423L14.6667 25.2435V63.7435C14.6667 64.4016 14.8782 64.9422 15.3013 65.3653C15.7243 65.7884 16.2649 65.9999 16.923 65.9999H71.077C71.7351 65.9999 72.2757 65.7884 72.6987 65.3653C73.1218 64.9422 73.3333 64.4016 73.3333 63.7435V37.2166C74.0338 37.0521 74.6778 36.8593 75.2654 36.6383C75.853 36.4174 76.4312 36.1448 77 35.8204V63.7435C77 65.4311 76.4347 66.8402 75.3042 67.9707C74.1736 69.1013 72.7645 69.6666 71.077 69.6666H16.923ZM69.6667 30.3204C67.1282 30.3204 64.9658 29.4272 63.1795 27.6409C61.3932 25.8546 60.5 23.6922 60.5 21.1537C60.5 18.6153 61.3932 16.4529 63.1795 14.6666C64.9658 12.8802 67.1282 11.9871 69.6667 11.9871C72.2052 11.9871 74.3675 12.8802 76.1538 14.6666C77.9402 16.4529 78.8333 18.6153 78.8333 21.1537C78.8333 23.6922 77.9402 25.8546 76.1538 27.6409C74.3675 29.4272 72.2052 30.3204 69.6667 30.3204Z",
    fill: "black"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 844,
    fill: "white",
    transform: "translate(-151 -184)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSopEmail);
export default __webpack_public_path__ + "static/media/sop_email.469757fa6424c3367752b99cbe191708.svg";
export { ForwardRef as ReactComponent };